import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useRegistration from "../../store/RegistrationStore";

import BackButton from "../../Components/BackButton";
import ModalConfirmation from "../../Components/ModalConfirmation/ModalConfirmation";

import { ReactComponent as ProviderIcon } from "../../static/images/provider_icon.svg";
import { ReactComponent as ConsumerIcon } from "../../static/images/consumer_icon.svg";

import "./style.scss";
import MainHeader from "../../Components/MainHeader/MainHeader";

const UserRoleSelector = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state, search } = useLocation();
  const [params] = useSearchParams();
  const isSSO = params.get("isSSO");

  const { handleExternalRegister } = useRegistration();

  const [confirmModalToggle, setConfirmModalToggle] = useState("");

  const handleSelectConsumer = () => {
    if (isSSO && !!state.email) {
      setConfirmModalToggle("modal-confirm");
    } else {
      navigate(`consumer-registration`);
    }
  };

  return (
    <div className="role-selector-container">
      <MainHeader />

      <ModalConfirmation
        modalText={t("role_selector_confirm_modal_title")}
        modalSubText={t("role_selector_confirm_modal_subtitle")}
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        confirm={handleExternalRegister}
      />

      <div className="role-selector-content">
        <div className="role-selector-header">
          <h2>{t(isSSO ? "almost_there" : "welcome")}</h2>
          <span>{t("manual_role_selector_header")}</span>
        </div>

        <div className="roles-selections-text">
          <h3>{t("provider_role")}</h3>
          <span>or</span>
          <h3>{t("consumer_role")}</h3>
        </div>
        <div className="user-section">
          <div
            className="user"
            onClick={() => {
              navigate(`provider-registration${search}`, {
                state,
              });
            }}
          >
            <div className="role-image">
              <ProviderIcon />
            </div>
            <div className="role-text">
              <span>{t("provider_role")}</span>
            </div>
          </div>
          <div className="user" onClick={handleSelectConsumer}>
            <div className="role-image">
              <ConsumerIcon />
            </div>
            <div className="role-text">
              <span>{t("consumer_role")}</span>
            </div>
          </div>
        </div>

        <BackButton />
      </div>
    </div>
  );
};

export default UserRoleSelector;
